import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { mdiInformationOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { mdiInformation } from "@mdi/js";
import Styles from "./FormState.scss";

const FormState = (props) => {
    const [forms, setForms] = useState([]);
    const [countCUA, setCountCUA] = useState(0);
    const [countCUB, setCountCUB] = useState(0);
    const [countRU, setCountRU] = useState(0);
    const [bigNumber, setBigNumber] = useState(0);

    let urgence = 8;

    useEffect(() => {}, [props.filter]);

    useEffect(() => {
        if (props.filter === "abonnement") {
            let now = new Date();
            let billingDate = props?.nextBillingDate
                ? new Date(Number(props?.nextBillingDate) * 1000)
                : null;
            setBigNumber(
                billingDate
                    ? Math.round(
                          (billingDate.getTime() - now.getTime()) /
                              (1000 * 3600 * 24)
                      )
                    : 0
            );
            return;
        }

        if (props.val?.length) {
            let count = props.val.filter((e) => {
                switch (props.filter) {
                    case "emergency":
                        return (
                            e.emergency_days <= 0 &&
                            e.emergency_days >= urgence * -1 &&
                            e.dem_state !== 1
                        );
                    case "current":
                        return e.emergency_days <= 0 && e.dem_state < 1;
                    case "abonnement":
                        return e.emergency_days <= 0 && e.dem_state < 2;
                    default:
                        return 1 === 1; /// all records !
                }
            });

            setBigNumber(count.length);
            setForms(count);
        }
    }, [props.val]);

    useEffect(() => {
        if (forms?.length) {
            let cua = forms.filter((e) => {
                return e.doctype.includes("CUA");
            });
            let cub = forms.filter((e) => {
                return e.doctype.includes("CUB");
            });
            let ru = forms.filter((e) => {
                return e.doctype.includes("RU");
            });
            setCountCUA(cua.length);
            setCountCUB(cub.length);
            setCountRU(ru.length);
        }
    }, [forms]);

    const getSubscriptionInfo = async () => {
        //let result = await axios.get('/Api/user/entity/invoices');
        //console.log(result?.data)
    };

    const renderDetail = () => {
        return (
            <div
                className={
                    "d-flex flex-row w-100 justify-content-center align-items-center font-weight-light text-center"
                }
            >
                {countCUB > 0 ? (
                    <div>
                        CUB{" "}
                        <span className={"font-weight-bold mx-1"}>
                            {countCUB}
                        </span>
                    </div>
                ) : null}
                {countCUA > 0 ? (
                    <div className={"ml-1"}>
                        CUA{" "}
                        <span className={"font-weight-bold mx-1"}>
                            {countCUA}
                        </span>
                    </div>
                ) : null}
                {countRU ? (
                    <div className={"ml-1"}>
                        RU{" "}
                        <span className={"font-weight-bold mx-1"}>
                            {countRU}
                        </span>
                    </div>
                ) : null}
                {props.filter === "abonnement" &&
                props?.currentSubscription?.length ? (
                    <div
                        className={
                            "d-flex flex-column justify-center align-content-center "
                        }
                        style={{ fontSize: "0.6rem" }}
                    >
                        <div className={"my-1"}>
                            {props.currentSubscription[0]?.name}
                        </div>
                        <div className={"my-1"}>
                            engagé le{" "}
                            <span className={"font-weight-bold"}>
                                {" "}
                                {new Date(
                                    props?.currentSubscription[0].created_at
                                ).toLocaleDateString()}
                            </span>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    };

    const handleClick = () => {
        if (props.filter === "abonnement") {
            getSubscriptionInfo();
        } else {
            props.setDashboardFilterForm(props.filter);
        }
    };

    return (
        <div
            className={
                "d-flex flex-column justify-content-center items-center text-white mx-md-2 p-3 mb-2 eu-form-state-panel "
            }
            onClick={() => handleClick()}
            style={{
                backgroundColor: props.color,
                flex: "1",
                boxShadow:
                    props.filterForms === props.filter
                        ? "#828588bf 4px 5px 5px 2px"
                        : "unset",
                border:
                    props.filterForms === props.filter
                        ? "rgba(50,50,50,0.1) 3px solid"
                        : "unset",
            }}
        >
            <div className={"d-flex w-100 items-center justify-center"}>
                <div
                    className={
                        "px-1 mr-2 py-1   rounded flex flex-column justify-center items-center bg-white"
                    }
                    style={{ height: "55px" }}
                >
                    <Icon
                        className={"my-auto"}
                        path={props.path}
                        size={2}
                        color={props.color}
                    />
                </div>
                <div
                    className={
                        "d-flex flex-column justify-content-center items-start"
                    }
                    style={{ minWidth: "99px" }}
                >
                    <div
                        className={"font-weight-bold mb-1"}
                        style={{ fontSize: "17px" }}
                    >
                        {props.title}
                    </div>
                    <p
                        className={"font-weight-bold mb-0"}
                        style={{ fontSize: "12px", lineHeight: "13px" }}
                    >
                        {props.subtitle}
                    </p>
                </div>
                {bigNumber ? (
                    <div
                        className={
                            "d-flex flex-column justify-content-center items-center w-100 h-100 pb-2"
                        }
                        style={{ fontSize: "30px" }}
                    >
                        <div className={"text-right font-weight-bold"}>
                            {bigNumber}
                        </div>
                    </div>
                ) : null}
            </div>
            {/*{(props.filter==='abonnement'&&!bigNumber)?
                    <div>Vous n'avez pas d'abonnement actif </div>
                    :null
                }*/}
            <div>
                {
                    //renderDetail()
                }
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        userId: state.MeReducer.id,
        username: state.MeReducer.username,
        role: state.MeReducer.role,
        currentPage: state.DashboardReducer.current_page,
        filterForms: state.DashboardReducer.filterForm,
        currentSubscription: state.MeReducer.currentSubscription,
        nextBillingDate: state.MeReducer.nextBillingDate,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        navigateTo: (e) => dispatch({ type: "SET_CURRENT_PAGE", data: e }),
        setCurrentCenterPage: (e) =>
            dispatch({ type: "SET_CURRENT_PAGE", data: e }),
        showCenterSection: (e) =>
            dispatch({ type: "SHOW_CENTER_SECTION", data: e }),
        setDashboardFilterForm: (e) =>
            dispatch({ type: "SET_DASHBORD_FILTER_FORM", data: e }),
    };
};

export default connect(mapStateToProps, mapDispatchTProps)(FormState);
